import "./namespace.js";
import "#/legacy/namespaces.js";

// A conditional filter's dependency state, written in the spelling its element reads:
// `sp-finder-filter` takes `prerequisite` ("met" / "unmet"), the legacy `doctor-finder-*-control`
// elements take `needs-state` ("satisfied" / "unsatisfied").
DoctorFinder.Helpers.FilterPrerequisite = {
  write(element, met) {
    if (element.matches("sp-finder-filter")) {
      element.setAttribute("prerequisite", met ? "met" : "unmet");
    } else {
      element.setAttribute("needs-state", met ? "satisfied" : "unsatisfied");
    }
  },
};
